import React, { useEffect, createElement } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { FloatingTestimonials } from './components/FloatingTestimonials';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { ForWhomSection } from './components/ForWhomSection';
import { WhatIncludes } from './components/WhatIncludes';
import { BonusSection } from './components/BonusSection';
import { PricingBlock } from './components/PricingBlock';
import { VisualSummary } from './components/VisualSummary';
import { HowItWorks } from './components/HowItWorks';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel('1313291250496067');
    // Add noscript tag
    if (!document.getElementById('meta-pixel-noscript')) {
      const noscript = document.createElement('noscript');
      noscript.id = 'meta-pixel-noscript';
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1313291250496067&ev=PageView&noscript=1" />`;
      document.body.appendChild(noscript);
    }
  }, []);
  return <div className="min-h-screen font-sans text-white selection:bg-brand-badge selection:text-white pb-0" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <FloatingTestimonials data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPoints data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <ForWhomSection data-id="element-7" />
        <WhatIncludes data-id="element-8" />
        <BonusSection data-id="element-9" />
        <PricingBlock data-id="element-10" />
        <VisualSummary data-id="element-11" />
        <HowItWorks data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <Testimonials data-id="element-14" />
        <FAQSection data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
    </div>;
}